import type { ItemCard, ProductCardBlock } from "@/types/content";
import { isBundleProductPage } from "@/types/product";

/**
 * Maps an ItemCard (from backend ItemCardViewModel) to a ProductCardBlock
 * so it can be rendered by the existing ProductCard component.
 */
export function itemCardToProductCard(item: ItemCard): ProductCardBlock {
  return {
    id: item.id,
    type: "productCardBlock",
    image: item.image ?? null,
    imageAlt: item.image?.altText ?? null,
    category: item.productCategory ?? null,
    productName: item.header,
    description: item.description ?? null,
    price: item.price?.formattedCalculatedPrice ?? null,
    priceInfo: item.price ?? null,
    productLink: item.link ?? null,
    productReference: item.productReference ?? null,
    sku: item.sku ?? null,
    variants: item.variants ?? null,
    // `ItemCard.type` is the Umbraco content-type alias, which the card block's own type would
    // otherwise overwrite — so the bundle facts are carried across explicitly.
    isBundle: isBundleProductPage(item),
    bundleNeedsVariantSelection: item.bundleNeedsVariantSelection ?? null,
  };
}
